import { Aprovador } from "./aprovador.model";
import { Eleicao } from "./eleicao.model";
import { PreCandidato } from "./preCandidato.model";

export class Candidatura  {
    constructor(
        public id?: number,
        public dataHoraInicioCandidaturas?: Date,
        public dataHoraFimCandidaturas?: Date,
        public dataHoraInicioAprovacao?: Date,
        public dataHoraFimAprovacao?: Date,
        public finalizada?: boolean,
        public eleicao?: Eleicao,
        public aprovadores?: Aprovador[],
        public precandidatos?: PreCandidato[],
        public qtAprovadoresDeferimento?: number,

    ) {   }    
}